import { render, staticRenderFns } from "./OssResult.vue?vue&type=template&id=5aa2be48&scoped=true"
import script from "./OssResult.vue?vue&type=script&lang=js"
export * from "./OssResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa2be48",
  null
  
)

export default component.exports